export const ReplacementsSteps = {
  itemSelect: 'item-select',
  issueSelect: 'issue-select',
  fitIssue: 'fit-issue',
  summary: 'summary',
  justRight: 'just-right',
  tailoringOnly: 'tailoring-only',
  tailoringEnd: 'tailoring-end',
  addressForm: 'address-form',
  confirmation: 'confirmation',
}

export const REPLACEMENTS_FIT_ISSUE = 'fit'
export const REPLACEMENTS_DAMAGED_ITEM_ISSUE = 'damaged'
export const REPLACEMENTS_WRONG_ITEM_ISSUE = 'wrong item'
export const REPLACEMENTS_MISSING_ITEM_ISSUE = 'missing'

export const ReplacementsIssueDisableStates = {
  [REPLACEMENTS_FIT_ISSUE]: [REPLACEMENTS_MISSING_ITEM_ISSUE, REPLACEMENTS_WRONG_ITEM_ISSUE],
  [REPLACEMENTS_DAMAGED_ITEM_ISSUE]: [
    REPLACEMENTS_MISSING_ITEM_ISSUE,
    REPLACEMENTS_WRONG_ITEM_ISSUE,
  ],
  [REPLACEMENTS_MISSING_ITEM_ISSUE]: [
    REPLACEMENTS_DAMAGED_ITEM_ISSUE,
    REPLACEMENTS_FIT_ISSUE,
    REPLACEMENTS_WRONG_ITEM_ISSUE,
  ],
  [REPLACEMENTS_WRONG_ITEM_ISSUE]: [
    REPLACEMENTS_DAMAGED_ITEM_ISSUE,
    REPLACEMENTS_FIT_ISSUE,
    REPLACEMENTS_MISSING_ITEM_ISSUE,
  ],
}

export const ReplacementsItemIssueOptions = [
  REPLACEMENTS_FIT_ISSUE,
  REPLACEMENTS_DAMAGED_ITEM_ISSUE,
  REPLACEMENTS_WRONG_ITEM_ISSUE,
  REPLACEMENTS_MISSING_ITEM_ISSUE,
]

export const ReplacementsEligibleProductCategoriesForFit = [
  'belts',
  'jackets',
  'pants',
  'shirts',
  'shoes',
  'vests',
]

export const BELT = 'belt'
export const JACKET_BODY = 'chest'
export const JACKET_LENGTH = 'jacketLength'
export const JACKET_SLEEVE = 'jacketSleeveTailoring'
export const SHIRT_NECK = 'neck'
export const SHIRT_SLEEVE = 'shirtSleeve'
export const SHIRT_BODY = 'shirtFit'
export const PANTS_INSEAM = 'inseam'
export const PANTS_INSEAM_TAILORING = 'inseamTailoring'
export const PANTS_WAIST = 'waist'
export const PANTS_SEAT = 'pantFit'
export const SHOES = 'shoe'
export const VEST_LENGTH = 'vestLength'
export const VEST_BODY = 'vest'

export const categoryFitMetaDataTypesMap = {
  belts: [BELT],
  jackets: [JACKET_BODY, JACKET_LENGTH, JACKET_SLEEVE],
  pants: [PANTS_WAIST, PANTS_INSEAM, PANTS_SEAT],
  shirts: [SHIRT_NECK, SHIRT_SLEEVE, SHIRT_BODY],
  shoes: [SHOES],
  vests: [VEST_BODY, VEST_LENGTH],
}

export const JACKET_SLEEVE_TAILORING_OPTIONS = 'jacketSleeveTailoringOptions'

export const categoryFitMetaDataTypesForOptionsMap = {
  ...categoryFitMetaDataTypesMap,
  // Ordering matters here since we show the questions on the fit questionnaire page in a specific sequence
  jackets: [JACKET_BODY, JACKET_LENGTH, JACKET_SLEEVE_TAILORING_OPTIONS],
}

export const JACKET_LENGTH_SORT_ORDER = ['XS', 'S', 'R', 'L', 'XL']
export const VEST_BODY_SORT_ORDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XXXXL']
export const VEST_LENGTH_SORT_ORDER = ['R', 'L']

export const TOO_TIGHT = 'Too tight'
export const TOO_LOOSE = 'Too loose'
export const TOO_SHORT = 'Too short'
export const TOO_LONG = 'Too long'
export const JUST_RIGHT = 'Just right'

export const METADATA_TYPE_API_KEY_MAP = {
  [BELT]: 'belt',
  [JACKET_BODY]: 'jacketBody',
  [JACKET_LENGTH]: 'jacketLength',
  [JACKET_SLEEVE]: 'jacketSleeve',
  [PANTS_INSEAM]: PANTS_INSEAM,
  [PANTS_SEAT]: 'seat',
  [PANTS_WAIST]: PANTS_WAIST,
  [SHIRT_BODY]: 'shirtBody',
  [SHIRT_NECK]: SHIRT_NECK,
  [SHIRT_SLEEVE]: [SHIRT_SLEEVE],
  [VEST_BODY]: 'vestBody',
  [VEST_LENGTH]: VEST_LENGTH,
}
